import React, { useEffect } from 'react'
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useLocation,
} from 'react-router-dom'
import useRoutes from '@/hooks/useRoutes'
import { useCurrentUser, useFetchRegionInfo } from '@/hooks'
import { Loading } from '@/components'
import Step from './Step'

const SignUp = () => {
  const { stepRoutes } = useRoutes()
  const { url } = useRouteMatch()
  const initialStepSlug = stepRoutes[0].path
  const { data: regionData, loading: regionLoading } = useFetchRegionInfo()
  const { userLoading } = useCurrentUser()
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  if ((!regionData && regionLoading) || userLoading) {
    return <Loading />
  }

  return (
    <>
      <Switch>
        {stepRoutes.map(({ key }) => (
          <Route exact key={key} path={`${url}/${key}`}>
            <Step stepSlug={key} />
          </Route>
        ))}
        <Redirect to={initialStepSlug} />
      </Switch>
    </>
  )
}

export default SignUp
